export default "__VITE_ASSET__BTWwUopf__"